import React, { useEffect, useRef, useState } from "react";
import "./ReportsView.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeftLong,
  faCertificate,
  faChartPie,
  faClose,
  faCopy,
  faEye,
  faFile,
  faPen,
  faPenToSquare,
  faShare,
  faTrashCan,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from "react-router-dom";

const config = require("../../config.js");

const translations = {
  english: {
    name: "Name",
    company: "Company",
    email: "Email",
    category: "Category",
    language: "Language",
    year: "Year",
    filters: "Filters",
    selectLanguage: "Select Language",
    action: "Actions",
    null: "Null",
    fiscalYear: "Fiscal Year",
    status: "Status",
    report: "Report",
    third: "3rd Party",
    certificate: "Verification",
    documents: "Expert Report",
    visible: "Visible",
    deleteDocument: "Are you sure you want to delete this document?",
    showDocument: "Are you sure you want to show this document to company?",
    hideDocument: "Are you sure you want to hide this document to company?",
    deleteOk: "Document deleted!",
    deleteError: "Failed to delete!",
    uploadOk: "Upload successful!", 
    uploadError: "Upload failed.",
    reportOk: "report deleted successfully",
    reportDelete:"Are you sure you want to send it back to the assessments section?"
  },
  german: {
    name: "Name",
    company: "Unternehmen",
    email: "E-Mail",
    category: "Kategorie",
    language: "Sprache",
    year: "Jahr",
    filters: "Filter",
    selectLanguage: "Sprache wählen",
    action: "Aktionen",
    null: "Null",
    fiscalYear: "Geschäftsjahr",
    status: "Status",
    report: "Bericht",
    third: "Drittanbieter",
    certificate: "Verifikation",
    documents: "Sachverständigenbericht",
    visible: "Sichtbar",
    deleteDocument: "Sind Sie sicher, dass Sie dieses Dokument löschen möchten?",
    showDocument: "Sind Sie sicher, dass Sie dieses Dokument dem Unternehmen zeigen möchten?",
    hideDocument: "Sind Sie sicher, dass Sie dieses Dokument vor dem Unternehmen verbergen möchten?",
    deleteOk: "Dokument gelöscht!",
    deleteError: "Löschen fehlgeschlagen!",
    uploadOk: "Upload erfolgreich!",
    uploadError: "Upload fehlgeschlagen.",
    reportOk: "Bericht erfolgreich gelöscht.",
    reportDelete: "Möchten Sie es wirklich an den Bewertungsbereich zurücksenden?"
  },
  czech: {
    name: "Jméno",
    company: "Společnost",
    email: "E-mail",
    category: "Kategorie",
    language: "Jazyk",
    year: "Rok",
    filters: "Filtry",
    selectLanguage: "Vyberte jazyk",
    action: "Akce",
    null: "Nil",
    fiscalYear: "Hospodářský rok",
    status: "Stav",
    report: "Zpráva",
    third: "Třetí strana",
    certificate: "Ověření",
    documents: "Odborná zpráva",
    visible: "Viditelné",
    deleteDocument: "Opravdu chcete smazat tento dokument?",
    showDocument: "Opravdu chcete tento dokument ukázat společnosti?",
    hideDocument: "Opravdu chcete tento dokument skrýt před společností?",
    deleteOk: "Dokument byl smazán!",
    deleteError: "Smazání selhalo!",
    uploadOk: "Nahrávání bylo úspěšné!",
    uploadError: "Nahrávání selhalo.",
    reportOk: "Zpráva byla úspěšně smazána.",
    reportDelete: "Jste si jistý/á, že to chcete poslat zpět do sekce hodnocení?"
},
  italian: {
    name: "Nome",
    company: "Azienda",
    email: "Email",
    category: "Categoria",
    language: "Lingua",
    year: "Anno",
    filters: "Filtri",
    selectLanguage: "Seleziona Lingua",
    action: "Azioni",
    null: "Nullo",
    fiscalYear: "Anno Fiscale",
    status: "Stato",
    report: "Rapporto",
    third: "Terza Parte",
    certificate: "Verifica",
    documents: "Rapporto Esperto",
    visible: "Visibile",
    deleteDocument: "Sei sicuro di voler eliminare questo documento?",
    showDocument: "Sei sicuro di voler mostrare questo documento all'azienda?",
    hideDocument: "Sei sicuro di voler nascondere questo documento all'azienda?",
    deleteOk: "Documento eliminato!",
    deleteError: "Eliminazione fallita!",
    uploadOk: "Caricamento riuscito!",
    uploadError: "Caricamento fallito.",
    reportOk: "Rapporto eliminato con successo.",
    reportDelete: "Sei sicuro di volerlo rispedire alla sezione assessments?"
  },
};

function ReportsThirdView() {
  const [Reports, setReports] = useState([]);
  const navigate = useNavigate();
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [selectedType, setSelectedType] = useState("");
  const { userId } = useParams();
  const fileInputRef = useRef(null);

  const handleIconClick = (reportId, type) => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
      setSelectedType(type);
      if(type == "docs") {
        setSelectedDocument(reportId);
      } else {
        setSelectedCertificate(reportId);
      }
    }
  };

  const deleteCertificate = async (reportId, type) => {
    try {
      const response = await fetch(
        config.env.API_BASE_URL + "/api/reports/" + reportId + "/" + type,
        {
          method: "DELETE",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      if (response.ok) {
        fetchReports();
        alert(lang.deleteOk);
      } else {
        alert(lang.deleteError);
      }
    } catch (error) {
      alert(lang.deleteError);
    }
  };

  const checkDocument = async (reportId, val) => {
      try {
        const response = await fetch(
          config.env.API_BASE_URL + "/api/reports/" + reportId + "/show/" + val,
          {
            method: "POST",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
  
        if (response.ok) {
          fetchReports();
        } else {
        }
      } catch (error) {
      }
    };

  const checkCertificate = async (reportId, val) => {
      try {
        const response = await fetch(
          config.env.API_BASE_URL + "/api/reports/" + reportId + "/showc/" + val,
          {
            method: "POST",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
  
        if (response.ok) {
          fetchReports();
        } else {
        }
      } catch (error) {
      }
    };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      console.log("File selected:", file.name);
      // Puoi gestire l'upload qui

      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await fetch(
          config.env.API_BASE_URL +
            "/api/reports/" +
            (selectedType == "docs" ? selectedDocument : selectedCertificate) +
            "/" + selectedType,
          {
            method: "POST",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
            body: formData,
          }
        );

        if (response.ok) {
          const result = await response.json();
          console.log("File successfully uploaded:", result);
          fetchReports();
          alert(lang.uploadOk);
        } else {
          console.error("Error uploading file:", response.statusText);
          alert(lang.uploadError);
        }

        setSelectedCertificate(null);
        setSelectedDocument(null);
        setSelectedType("");
      } catch (error) {
        setSelectedCertificate(null);
        setSelectedDocument(null);
        setSelectedType("");
        alert(lang.uploadError);
      }
    }
  };

  const fetchReports = async () => {
    try {
      const response = await fetch(
        config.env.API_BASE_URL + "/api/reports/thirds/" + userId,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
        setReports(data);
      } else {
        console.error("Failed to fetch Reports");
      }
    } catch (error) {
      console.error("Error fetching Reports:", error);
    }
  };

  useEffect(() => {
    fetchReports(); // Fetch Reports on component mount
  }, []);

  const GoToAssessment = (reportId) => {
    navigate(`/reports/report/view/${reportId}`);
  };

  const GoToReport = (year,userId) => {
    navigate(`/reports?reportYear=${year}&userId=${userId}`);
  };

  const getByStatus = (status) => {
    if (status == 0) return "Loaded";

    if (status == 1) return "Sent";

    if (status == 2) return "Assigned";

    if (status == 3) return "Certificated";
  };

  const [currentLanguage] = useState(
      localStorage.getItem("language") || "english"
    );
  
  let lang = translations[currentLanguage];
const GoBack = () => {
    window.history.back();
  }
  return (
    <>
      <input
        type="file"
        style={{ display: "none" }}
        ref={fileInputRef}
        onChange={handleFileChange}
      />
      <div style={{cursor:"pointer", left: "30px", position: "absolute", top: "55px"}} onClick={() => GoBack()}>
                  <FontAwesomeIcon icon={faArrowLeftLong} />
                  <span style={{ marginLeft: "10px" }}>Back</span>
                </div>
      <div className="mt-5 Crud-main-container container">
        <table className="table Crud-main container">
          <thead>
            <tr className="Crud-thead-wrapper">
              <th scope="col">{lang.fiscalYear}</th>
              <th scope="col">{lang.status}</th>
              <th scope="col">{lang.company}</th>
              <th scope="col">{lang.email}</th>
              <th scope="col">{lang.report}</th>
              <th scope="col">{lang.documents}</th>
              <th scope="col">{lang.certificate}</th>
              
            </tr>
          </thead>
          <tbody>
            {Reports.slice().map((report) => (
              <tr key={report._id}>
                <td>{report.fiscalYear}</td>
                <td>{getByStatus(report.status)}</td>
                <td>{report.userId?.companyName}</td>
                <td>{report.userId?.email}</td>
                <td style={{ width: "110px"}}>
                  <FontAwesomeIcon
                    icon={faEye}
                    onClick={() => {
                      GoToAssessment(report._id);
                    }}
                  />

                  <FontAwesomeIcon
                      icon={faChartPie}
                      style={{marginLeft: "10px"}}
                      onClick={() => {
                          GoToReport(report.fiscalYear, report.userId._id);
                      }}
                  />
                </td>
                                <td>
                                  {report.document && (
                                    <>
                                      <a
                                        style={{ marginLeft: "10px" }}
                                        href={config.env.STORAGE_URL + report.document}
                                        target="_blank"
                                      >
                                        <FontAwesomeIcon icon={faFile} />
                                      </a>
                                    </>
                                  )}
                                </td>
                                <td>
                                  <FontAwesomeIcon
                                    icon={faUpload}
                                    onClick={() => handleIconClick(report._id, "certificate")}
                                  />
                                  {report.certificate && (
                                    <>
                                      <a
                                        style={{ marginLeft: "10px" }}
                                        href={config.env.STORAGE_URL + report.certificate}
                                        target="_blank"
                                      >
                                        <FontAwesomeIcon icon={faCertificate} />
                                      </a>
                
                                      <FontAwesomeIcon
                                        style={{ marginLeft: "10px" }}
                                        onClick={() => {
                                          if (
                                            window.confirm(
                                              lang.deleteDocument
                                            )
                                          ) {
                                            deleteCertificate(report._id, "certificate");
                                          }
                                        }}
                                        icon={faClose}
                                      />

                                      <input style={{ marginLeft: "10px" }} checked={report.showc} value={report.showc} type="checkbox" onChange={(e) => {
                                          let val = report.showc;
                                          var text = report.showc ? lang.hideDocument : lang.showDocument;
                                          if (
                                            window.confirm(text)
                                          ) {
                                            checkCertificate(report._id, report.showc ? false : true);
                                          } else {
                                            report.showc = val;
                                          }
                                        }} />
                                    </>
                                  )}
                                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default ReportsThirdView;
